/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Studio_DescInputs */

const en_mk_nav_studio_desc = /** @type {(inputs: Mk_Nav_Studio_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From proposals to client handover.`)
};

const id_mk_nav_studio_desc = /** @type {(inputs: Mk_Nav_Studio_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposal hingga serah terima ke klien.`)
};

/**
* | output |
* | --- |
* | "From proposals to client handover." |
*
* @param {Mk_Nav_Studio_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_studio_desc = /** @type {((inputs?: Mk_Nav_Studio_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Studio_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_studio_desc(inputs)
	return en_mk_nav_studio_desc(inputs)
});